module.exports = __webpack_public_path__ + "static/media/glance2.956d8f17.jpeg";